import {Component} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DialogRef} from '../../dialog/dialog-ref';

/**
 * This component uses in modal window for entering one text value
 */
@Component({
  selector: 'app-link-doc-modal',
  templateUrl: './link-doc-modal.component.html',
  styleUrls: ['./link-doc-modal.component.scss'],
})
export class LinkDocModalComponent {
  public link: UntypedFormControl = new UntypedFormControl(''); // controls with link to the document

  constructor(private dialogRef: DialogRef) {}

  /**
   * save method closes modal window and send value from link control
   */
  save() {
    this.dialogRef.close(this.link.value);
  }

  /**
   * cancel method closes modal window and send null
   */
  cancel() {
    this.dialogRef.close();
  }
}
